import "./App.css";
import Login from "./Auth/login";
function App() {
  return (
    <>
      <Login />
    </>
  );
}

export default App;
